// Flip cards.
// Hover alone is unreachable by keyboard and unusable on touch, so the front of
// each card is a button that turns it over, and a tap on the back (other than
// its Read more link) turns it back; CSS handles hover and focus.

export default function flipCards() {
    document.querySelectorAll('.amu-flip-inner').forEach((card) => {
        const front = card.querySelector('.amu-flip-front');
        const back = card.querySelector('.amu-flip-back');

        function flip(flipped) {
            card.classList.toggle('is-flipped', flipped);
            front.setAttribute('aria-expanded', flipped ? 'true' : 'false');
        }

        front.addEventListener('click', () => flip(true));

        back.addEventListener('click', (event) => {
            if (!event.target.closest('a')) {
                flip(false);
            }
        });
    });
}
